/* © 2014 - Copyright of Aetonix Systems Inc - All Rights Reserved. Patent pending.
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Aetonix, June 19, 2014
 * For information or permission request, email info@aetonixsystems.com
 */

var Model = require("../types/Model.js");

module.exports = Model({
	name: "managedmetrics",
	init: init,
	uninit: uninit,
	listeners: listeners,
	triggers: triggers,

	_who: null,
	_group: null,

	refresh: refresh,
	reset: reset,
	track_metrics: track_metrics,
	sayViewing: sayViewing
});

/**
 * Adds listeners for changes in the metrics,
 * @return {Promise} Resolves to the initial state
 */
function init() {
	this._who_tracker = this.dispatcher.createTracker(); //Create tracker object.
	this.reset();
	this.refresh();
}

/**
 * Clears extra data
 * @return {Promise} Resolves after everything is done.
 */
function uninit() {
	this._metrics = null;
}

function listeners() {
	return {
		"connectivity:online": refresh,
	};
}

function triggers() {
	return {
		"create:accept": metrics_create,
		"create:start": metrics_create_start,
		"create:cancel": metrics_create_cancel,
		"view": view,
		"reset": reset
	};
}

function view(data) {
	var who = data.who;
	const group = data.group;

	if(who === this._who) return this.sayViewing();

	this._who = who;
	this._group = group;

	this.refresh().then(sayViewing.bind(this));
	this.track_metrics();

	this.emit("usermetrics:trigger:track", "view managed user's metrics", {
		who,
	});
}

function refresh() {
	var managee = this._who;
	if (!managee) return;
	var group = this._group;

	this.emit("save:trigger:start");
	return this.api.manage.metrics
		.cumulative(managee, group)
		.then(setCumulative.bind(this))
		.catch(console.error.bind(console))
		.then(finish_load.bind(this));
}

function sayViewing() {
	this.dispatch("viewing", {
		who: this._who,
		group: this._group
	});
}

function finish_load() {
	this.emit("save:trigger:finish");
}

function setCumulative(data) {
	this.extend({
		cumulative: data
	});
}

function metrics_create(data) {
	var type = data.type;
	if (!type) return;
	var managee = this._who;
	if (!managee) return;
	const group = this._group;
	this.api.manage.metrics.add(managee, type, group).catch(console.error.bind(console));
	this.extend({
		confirming: false
	});

	this.emit("usermetrics:trigger:track", "create managed user's metric", {
		who: managee,
		type,
	});
}

function metrics_create_start(data) {
	var type = data.type;
	if (!type) return;
	this.extend({
		confirming: type
	});
	this.emit("usermetrics:trigger:track", "begin creating managed user's metric", {
		who: this._who,
		type,
	});
}

function metrics_create_cancel() {
	this.extend({
		confirming: false
	});
	this.emit("usermetrics:trigger:track", "cancel creating managed user's metric", {
		who: this._who,
	});
}

function track_metrics() {
	var managee = this._who;
	var tracker = this._who_tracker;
	var group = this._group;
	tracker.off();
	tracker.on("mqtt:u/" + managee + "/settings", reloadIfTestModeOff.bind(this));
	if(group)
		tracker.on("mqtt:managegroup/" + group + "/patient/u/" + managee + "/metric/to/add", refresh.bind(this));
	else
		tracker.on("mqtt:u/" + managee + "/metric/to/add", refresh.bind(this));
}

function reloadIfTestModeOff(data) {
	if(data.testModeEnabled === null) {
		this.refresh();
	}
}

function reset() {
	this.emit("usermetrics:trigger:track", "close managed user's metrics", {
		who: this._who,
	});
	this._who = null;
	this._who_tracker.off();
	this.push({
		cumulative: {
			consents_signed: 0,
			cpps_initiated: 0,
			care_conferences: 0,
			client_surveys_distributed: 0,
			home_visits: 0,
			caregiver_phone_calls: 0,
			summaries_left_with_client: 0,
			direct_communications_with_physicians: 0,
			ccps_given_to_careteam: 0,
			community_resources_contacted: 0,
			care_goals_defined: 0
		},
		confirming: false,
	});
}
